import { Popover as RPopover } from "radix-ui";
import type { ReactNode } from "react";

import styles from "./Popover.module.css";
import { cx } from "../lib/cx";

export const Popover = RPopover.Root;
export const PopoverTrigger = RPopover.Trigger;
export const PopoverClose = RPopover.Close;

export type PopoverContentProps = {
  readonly align?: "center" | "end" | "start";
  readonly children: ReactNode;
  readonly className?: string;
  readonly onOpenAutoFocus?: (event: Event) => void;
  readonly side?: "bottom" | "left" | "right" | "top";
  readonly sideOffset?: number;
};

export const PopoverContent = ({
  align = "start",
  children,
  className,
  onOpenAutoFocus,
  side = "bottom",
  sideOffset = 6,
}: PopoverContentProps) => (
  <RPopover.Portal>
    <RPopover.Content
      align={align}
      className={cx(styles.content, "u-pop", className)}
      onOpenAutoFocus={onOpenAutoFocus}
      side={side}
      sideOffset={sideOffset}
    >
      {children}
    </RPopover.Content>
  </RPopover.Portal>
);
